import {toast} from 'react-toastify';
import {registerErrorCallback, registerMessageProvier} from '../apis/errorHandling';
import {MessageProvider} from '../i18n/i18n';

export const bootGlobalApiErrorHandling = (i18n: MessageProvider) => {
    registerMessageProvier(i18n);
    registerErrorCallback((errorMessage) => {
        toast.error(errorMessage);
    });
};



// WEBPACK FOOTER //
// ./src/boot/globalErrorHandling.ts